var map = {
	"./denys-nevozhai-7nrsVjvALnA-unsplash-1920.jpg": 8540,
	"./madara-parma-5lgC0sAa6Gg-unsplash-1920.jpg": 84187,
	"./marco-xu-cGViI7fgmGE-unsplash-1920.jpg": 22362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58058;